import { CircularProgress } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { Autocomplete } from '@material-ui/lab';
import { RenderInputParams } from '@material-ui/lab/Autocomplete';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import gql from 'graphql-tag';
import * as React from 'react';
import { graphql } from 'react-apollo';

interface SelectorProps {
    onSelection?: (selection: object, name: string) => void;
    // tslint:disable-next-line: no-any
    items?: any;
    required?: boolean;
    label?: string;
    name: string;
    data: RoleListData;
    value: string; // code
    disabled: boolean;
    isActive: boolean;
    isFeeEarner: boolean;
    isExternal?: boolean;
    variant?: 'standard' | 'outlined' | 'filled';
    size?: 'small' | 'medium';
}

interface SelectorState {
    selectedCode: string;
    selectedLabel: string;
}

export interface RoleListData {
    loading?: boolean;
    networkStatus?: number;
    roleList: RoleList;
}

export interface RoleList {
    role: Role[];    
}

export interface Role {
    roleIdString: string;
    rolename: string;
    isExternal: boolean;
}

class Selector extends React.Component<SelectorProps, SelectorState> {
    // tslint:disable-next-line: no-any
    public roles: any;

    constructor(props: SelectorProps, state?: SelectorState) {
        super(props, state);

        this.handleChange = this.handleChange.bind(this);

        this.state = {
            selectedCode: '',
            selectedLabel: ''
        };
    }

    public UNSAFE_componentWillReceiveProps(nextProps: SelectorProps) {
        if (this.props.value !== nextProps.value && this.roles) {
            // tslint:disable-next-line: no-any
            const filteredItem = this.roles.find((item: any) => item.value.toLowerCase().includes(nextProps.value.toLowerCase()));

            if (filteredItem && nextProps.value.toString() !== '') {
                this.setState({
                    selectedCode: filteredItem.value,
                    selectedLabel: filteredItem.label
                });
            } else {
                this.setState({
                    selectedCode: '',
                    selectedLabel: ''
                });
            }           
        }
    }

    public render() {
        if (!this.props.data.loading || this.props.data.roleList) {
            const roleList: RoleList = this.props.data.roleList;
            this.roles = roleList.role.map( (role: Role) => {
                return ({ value: role.roleIdString, label: role.rolename });
            });
        } else { 
            this.roles = [];
        }   

        return (
            <div className={'downshift-wrapper'}>
                <Autocomplete
                    loading={this.props.data.loading}
                    disabled={this.props.disabled}
                    autoSelect={true}
                    value={{value: this.state.selectedCode, label: this.state.selectedLabel}}
                    onChange={this.handleChange}
                    options={this.roles}
                    // tslint:disable-next-line: jsx-no-lambda
                    getOptionLabel={option => option.label}        
                    getOptionSelected={(option, value) => value.value === option.value}    
                    size={this.props.size || 'medium'}        
                    // tslint:disable-next-line: jsx-no-lambda
                    renderInput={params => (
                        <TextField 
                            {...params} 
                            label={this.props.label} 
                            variant={this.props.variant || 'standard'} 
                            size={this.props.size || 'medium'}
                            fullWidth={true} 
                            margin="none" 
                            required={this.props.required}
                            InputProps={this.getInputProps(params, this.props.data.loading)}
                        />
                    )}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderOption={(option, { inputValue }) => {
                        const matches = match(option.label, inputValue);
                        const parts = parse(option.label, matches);
                
                        return (
                          <div>
                            {parts.map((part, index) => (
                              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                {part.text}
                              </span>
                            ))}
                          </div>
                        );
                      }}
                />
            </div>
        );
    }

    private getInputProps(params: RenderInputParams, isLoading?: boolean) {
        return  ({   
            ...params.InputProps,
            endAdornment: (
                <React.Fragment>
                  {isLoading ? <CircularProgress color="primary" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),     
         });
    }

    // tslint:disable-next-line: no-any
    private handleChange(event: object, item: any) {        
        this.setState( {
            selectedCode: item ? item.value : '',
            selectedLabel: item ? item.label : ''
        });

        if (this.props.onSelection) {
            this.props.onSelection({
                                        label: item ? item.label : '', 
                                        value: item ? item.value : ''
                                    // tslint:disable-next-line: align
                                    }, this.props.name);
        }       
    }      
} 

const RoleSelectorData = gql`
query roleSelectorQuery( $isExternal: Boolean) {
    roleList(isExternal: $isExternal) {
        role {
            roleIdString,
            rolename,
            isExternal
        }
    }
}`;

// tslint:disable-next-line: no-any
export const RoleSelector = graphql<any, SelectorProps, any> (RoleSelectorData, {
        options: (props: SelectorProps) => ({  
            fetchPolicy: 'cache-first',
            variables: {
                isExternal: props.isExternal === undefined ? null : props.isExternal
            }         
        })
    })
    (Selector);
    